import apiClient from "./apiClient";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { ExpenseResponse } from "../models/ResponseModels/ExpenseResponse";
import { CreateExpenseRequest } from "../models/RequestModels/CreateExpenseRequest";
import { UpdateExpenseRequest } from "../models/RequestModels/UpdateExpenseRequest";

interface GetExpensesParams {
  from?: string;
  until?: string;
  property_id?: number;
  unit_id?: number;
  currency?: string;
}

export const getExpensesRequest = async (
  params?: GetExpensesParams,
): Promise<ApiCollectionResponse<ExpenseResponse>> => {
  const response = await apiClient.get<ApiCollectionResponse<ExpenseResponse>>(
    "/expenses",
    { params },
  );

  return response.data;
};

export const createExpenseRequest = async (
  body: CreateExpenseRequest,
): Promise<ApiSingleResponse<ExpenseResponse>> => {
  const response = await apiClient.post<ApiSingleResponse<ExpenseResponse>>(
    "/expenses",
    body,
  );

  return response.data;
};

export const updateExpenseRequest = async (
  id: number,
  body: UpdateExpenseRequest,
): Promise<ApiSingleResponse<ExpenseResponse>> => {
  const response = await apiClient.put<ApiSingleResponse<ExpenseResponse>>(
    `/expenses/${id}`,
    body,
  );

  return response.data;
};

export const deleteExpenseRequest = async (id: number): Promise<void> => {
  await apiClient.delete(`/expenses/${id}`);
};
